import React, { useEffect } from "react";
import { Spinner, Row, Col } from "react-bootstrap";
import { getNotifications } from "../../store/actions/alert"
import  NotificationCard  from "./NotificationCard";
import { connect } from "react-redux";
import InfiniteScroll from 'react-infinite-scroll-component';
import "./Alert.css";

const AlertComponent = ({notifications, page, hasMore, getNotifications}) => {
    useEffect(() => {
       getNotifications();
    },[]);

    const fetchNextPage = () => {
    // Increment to next page when user scrolls down
    console.log("========== INFINITE SCROLL ==========");
    console.log("Current page:", page);
    console.log("Next page:", page + 1);
    console.log("Has more:", hasMore);
    getNotifications(page + 1);
  };
    return (
    <>
        <InfiniteScroll
                    dataLength={notifications.length}
                    next={fetchNextPage}
                    hasMore={hasMore}
                    scrollableTarget="alerts-scroll-container"
                    loader={
                        <div className="notification-loader">
                          <Spinner
                              animation="border"
                              size="sm"
                              role="status"
                          />
                          <span>Loading more alerts...</span>
                      </div>
                    }
                    endMessage={
                      <p style={{ textAlign: "center", margin: "30px 0px" }}>
                      {notifications.length > 0 ? (
                        <b>No more alerts found</b>
                      ) : (
                        <b>No Alerts Found</b>
                      )}
                    </p>
                    }
                  >
                      <Row>
                        {notifications.map((notification) => (
                            <Col key={notification.ContentId} xs={12}>
                                <NotificationCard
                                    content={notification.Content_String}
                                    CreatedDate={notification.CreatedDate}
                                />
                            </Col>
                        ))}
                    </Row>
        </InfiniteScroll>
    </>
    );
  };
  const mapStateToProps = (state) => {
    return {
      notifications: state.alert.list,
      page: state.alert.page,
      hasMore: state.alert.hasMore
    };
  };
  export default connect(mapStateToProps, {
    getNotifications
  })(AlertComponent);